import type { ReactNode } from 'react'

/**
 * One key/value row for the IDENTITY and THREAD blocks — README "4. Context
 * + AI pane (pane C)". `value` is a `ReactNode`, not just a `string` — the
 * Confidence row (visual findings item 3) renders a `shield-check`/`user`
 * tier pill here, the same badge markup the thread header uses, not plain
 * text.
 */
export interface KvRowProps {
  label: string
  value: ReactNode
  valueClassName?: string
  testId?: string
}

export function KvRow({ label, value, valueClassName = 'text-hi', testId }: KvRowProps) {
  return (
    <div className="flex items-start justify-between gap-2" data-testid={testId}>
      <div className="text-[11px] text-lo">{label}</div>
      <div className={['max-w-[150px] text-right text-[11px]', valueClassName].join(' ')}>{value}</div>
    </div>
  )
}
